import React from "react";
import BackgroundActivities from "./PageBackgrounds/BackgroundActivities.jsx";
import "./Headers.css";
import Boogers from "../../media/Boogers.JPG";

export default function ActivitiesHeader() {
    return (
        <>
        <div className="Headers">
        <BackgroundActivities />
        </div>
        </>
    );
}
